module.exports = __webpack_public_path__ + "img/profile-background-grey.1242a792.svg";